<template>
<div>
  <v-expansion-panels
    :multiple="true"
    v-model="filterExpandArray"
    class="elevation-0 pa-0"
    flat
  >
    <v-expansion-panel
      v-for="(filter, index) in arrFilters"
      :key="index"
      class="wrld_background pa-0"
    >
      <v-expansion-panel-header
      class="pa-1"
      color="#FAFAFA"
      >
        <span
         class="filter--title"
        >{{ filter.title }}
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pa-0" color="#FAFAFA">
        <div>
            <WrldSelectableFiltersInput
              v-show="filter.isSearchable !== undefined ? filter.isSearchable : true"
              @input="handleSearch.apply(null, [$event, filter.attribute, index])"
              @empty-input="handleEmptySearch.apply(null, [$event, filter.attribute, index])"
            />
            <!-- <span v-if="isFromSearch && !items.length">{{ $t('orders.no_results') }}</span> -->
            <template>
              <v-checkbox
                class="mt-1"
                v-for="(item, index) in getResourceFacet(filter.attribute)"
                :key="item.value + item.isChecked"
                v-model="item.isChecked"
                @change="handleChecked.apply(null, [$event, item, filter.attribute, index])"
                color="kazan"
                hide-details
              >
                <template v-slot:label>
                  <span
                    v-if="filter.colorMap"
                    class="coloredCircle"
                    :style="'background-color: ' + filter.colorMap[item.label]"
                  ></span>
                  <span v-if="filter.i18nPreffix">
                    {{ $t(filter.i18nPreffix + item.value) }}
                  </span>
                  <span v-else>
                    {{item.value}}
                  </span>
                  <v-chip
                    v-if="!filter.hideNumber"
                    color="secondary"
                    small
                    class="wrld_subtitle--text"
                  >
                  <span>
                    {{ item.count.toLocaleString() }}
                  </span>
                </v-chip>
                </template>
              </v-checkbox>
            </template>
          </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WrldSelectableFiltersInput from '@/components/wrld/filters/WrldSelectableFiltersInput'

export default {
  name: 'WrldSelectableFilters',
  components: {
    WrldSelectableFiltersInput
  },
  props: {
    arrFilters: Array,
    wrld: { type: Object, default: () => null },
    isGenericResource: {type: Boolean, default: true}
  },
  data () {
    return {
      filterExpandArray: [],
      filterIsOpen: [],
      textQuery: ''
    }
  },
  mounted () {
    // this.filterExpandArray = [].concat(this.arrFilters.map((filter) => false))
    this.filterIsOpen = [].concat(this.arrFilters.map((filter) => false))
    this.setResourceFacetsFromUrl({ url: this.$route.query })
    this.handleExpandOnMount(this.$route.query)
  },
  methods: {
    ...mapActions({
      setResourceFacets: 'setResourceFacets',
      setResourceFacetsFromUrl: 'setResourceFacetsFromUrl',
      setCheckedFacet: 'setCheckedFacet',
      setFilterQuery: 'setFilterQuery',
      setResourceOverviewList: 'setResourceOverviewList'
    }),
    handleChecked (evt, item, facet, index) {
      this.setCheckedFacet({ index, item, facet })
      this.setFilterQuery({ queryArrayFacet: this.getCheckedFacets, queryPage: this.getActualListPage, querySearchText: this.getSearchQuery, queryRefSearch: this.getReferenceQuery })
      // Create Query Filters
      if (this.isGenericResource) {
        this.setResourceOverviewList({ index: this.wrld.index, query: this.getSearchQuery, filters: this.getCheckedFacets, page: 0, pageSize: this.wrld.pageSize, rangeFilters: this.getRangeFiltersForSearchQuery })
      }
      const facetIndex = this.arrFilters.findIndex(({ attribute }) => attribute === facet)
      this.filterIsOpen.forEach((value, openIndex) => {
        if (value && openIndex !== facetIndex) {
          this.handleQueryExpand({ index: openIndex, isChanged: true })
        }
      })
    },
    handleExpandOnMount (url) {
      Object.keys(url).forEach((key) => {
        const facet = key.split('=')[1]
        const filterIndex = this.arrFilters.findIndex(({ attribute }) => attribute === facet)
        if (filterIndex >= 0) {
          this.filterExpandArray.push(filterIndex)
          this.filterIsOpen[filterIndex] = true
          this.handleQueryExpand({ index: filterIndex, isMount: true })
        }
      })
    },
    handleQueryExpand ({ index, isMount = false, isChanged = false }) {
      if (!this.filterIsOpen[index]) {
        this.setResourceFacets({ index: this.wrld.facetIndex, facet: this.arrFilters[index].attribute, urlFacets: this.$route.query, filters: this.getFiltersForSearchQuery, defaultValues: this.arrFilters[index].defaultValues, rangeFilters: this.getRangeFiltersForSearchQuery })
      } else if (isMount) {
        this.setResourceFacets({ index: this.wrld.facetIndex, facet: this.arrFilters[index].attribute, urlFacets: this.$route.query, filters: this.getFiltersForSearchQuery, defaultValues: this.arrFilters[index].defaultValues, rangeFilters: this.getRangeFiltersForSearchQuery })
         this.setFilterQuery({ queryArrayFacet: this.getCheckedFacets, queryPage: this.getActualListPage, querySearchText: this.getSearchQuery, queryRefSearch: this.getReferenceQuery })
      } else if (isChanged) {
        this.setResourceFacets({ index: this.wrld.facetIndex, facet: this.arrFilters[index].attribute, checkedFacets: this.getResourceFacet(this.arrFilters[index].attribute), filters: this.getFiltersForSearchQuery, defaultValues: this.arrFilters[index].defaultValues, rangeFilters: this.getRangeFiltersForSearchQuery })
      }
    },
    handleSearch (query, facet, index) {
      if (query != null) {
        this.textQuery = query
        if (query.length > 0) {
          setTimeout(() => {
            this.setResourceFacets({ query, index: this.wrld.facetIndex, facet: this.arrFilters[index].attribute, checkedFacets: this.getResourceCheckedFacet(this.arrFilters[index].attribute), filters: this.getFiltersForSearchQuery, defaultValues: this.arrFilters[index].defaultValues, rangeFilters: this.getRangeFiltersForSearchQuery })
          }, 300)
        }
      }
    },
    handleEmptySearch (query, facet, index) {
      setTimeout(() => {
        this.setResourceFacets({ query: '', index: this.wrld.facetIndex, facet: this.arrFilters[index].attribute, checkedFacets: this.getResourceCheckedFacet(this.arrFilters[index].attribute), filters: this.getFiltersForSearchQuery, defaultValues: this.arrFilters[index].defaultValues, rangeFilters: this.getRangeFiltersForSearchQuery })
      }, 300)
    }
  },
  computed: {
    ...mapGetters([
      'getResourceFacet',
      'getCheckedFacets',
      'getCheckedFacetsForFilters',
      'getResourceCheckedFacet',
      'getSearchQuery',
      'getActualListPage',
      'getReferenceQuery',
      'getCurrentRangeFilters',
      'getFiltersForSearchQuery',
      'getRangeFiltersForSearchQuery',
      'getFiltersQuery'
    ])
  },
  watch: {
    getFiltersQuery: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        this.filterIsOpen.forEach((val, index) => {
          if (val) {
            this.handleQueryExpand({ index, isChanged: true })
          }
        })
      }
    },
    filterExpandArray: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (oldVal != null) {
          val.forEach((value) => {
            this.handleQueryExpand({ index: value })
            this.filterIsOpen[value] = true
          })
        }
      }
    },
    filterIsOpen: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (oldVal === undefined) {
          oldVal = [].concat(val)
        }
        val.forEach((val, index) => {
          if (oldVal[index] !== val && val) {
            this.handleQueryExpand({ index })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .filter--title {
    font-size: 13px;
    font-weight: 500;
  }
</style>
